import React, { useEffect } from "react";
import "./doctor.scss";
import { briefcaase_icon, honor_icon } from "../../assets/icons";
import { doctordetailimg } from "../../assets/images";
import { PublicService } from "../../services";
import { useQuery } from "@tanstack/react-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";

const DoctorDetails = () => {
  const { doctorId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  // const doctorId = location.state?.id;
  const { getDoctorDetail } = PublicService();

  const doctors = useQuery({
    queryKey: ["doctors"],
    queryFn: () => getDoctorDetail({ doctorId: doctorId }),
  });

  // console.log("update doctors",doctors);

  useEffect(() => {
    if (!doctorId) {
      navigate("/doctors");
    }
  }, [location.state]);

  const doctorsDetail = doctors?.data?.data?.doctor;
  // console.log("update doctor doctorsDetails",doctorsDetail);
  return (
    <>
      {!doctors?.isLoading && doctorsDetail?.name && (
        <Helmet defer={false}>
          <title>
            {` ${doctorsDetail?.name} - ${doctorsDetail?.specialization}, Book an appointment now! `}
          </title>
          <meta
            name="description"
            content={`Looking for a ${doctorsDetail?.specialization} near you in Delhi NCR. Book an appointment with ${doctorsDetail?.name}, view fees & read verified reviews on Holypills.`}
          />
          <link href={window.location.href} rel="canonical"></link>
        </Helmet>
      )}

      <div className="wrapper_doctor_details">
        <div className="land_tittle">
          <h1 className="title">{doctorsDetail?.name}</h1>
        </div>
        <div className="wrap_doctor_details spacing">
          <div className="container">
            <div className="wrap_cards_details">
              <div className="wrap_left">
                <div className="wrap_img_profile">
                  <figure>
                    <img src={doctorsDetail?.profile} alt="doctor-image" />
                  </figure>
                  <h3>{doctorsDetail?.name} </h3>
                  <ul>
                    <li>
                      <img src={honor_icon} alt="honor_icon" />
                      <span>{doctorsDetail?.specialization}</span>
                    </li>
                    <li>
                      <img src={briefcaase_icon} alt="briefcaase_icon" />
                      <span>{doctorsDetail?.experience} years of exp.</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="wrap_right">
                <p className="bold_txt">{doctorsDetail?.aboutUs || ""}</p>
                {/* <p>
                Exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex
                ea commodo non habent claritatem insitamconsequat duis autem
                facilisis at vero eros vel eum iriure. Duis autem vel eum iriure
                dolor in hendrerit in vulputate velit esse molestie consequat,
                vel illum dolore eu feugiat nulla facilisis at vero eros et
                accumsan et iusto odio dignissim qui blandit praesent luptatum
                zzril delenit augue duis dolore te feugait nulla facilisi.Exerci
                tation ullamcorper
              </p> */}

                <ul>
                  <li>
                    <span className="blue_txt">Qualifications:</span>
                    <span>{doctorsDetail?.qualification}</span>
                  </li>
                  <li>
                    <span className="blue_txt">Years of Experience:</span>
                    <span>{doctorsDetail?.experience} Years</span>
                  </li>
                  <li>
                    <span className="blue_txt">Locations:</span>
                    <span>{doctorsDetail?.address}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DoctorDetails;
